import React from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../../App/Components/TabbedView/TabbedView";
import { JobGroups } from "../../../App/Enums/JobGroups";
import JobGroupsPage from "../JobsGroupsPage";

function JobGroupsTabs() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);

  const tabs = [
    {
      title: "Industries",
      component: <JobGroupsPage jobType={JobGroups.Industry} />,
    },
    {
      title: "Families",
      component: <JobGroupsPage jobType={JobGroups.Family} />,
    },
    {
      title: "Categories",
      component: <JobGroupsPage jobType={JobGroups.Category} />,
    },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Job Groups
        </h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <TabbedView tabs={tabs} />
          )}
        </div>
      </div>
    </>
  );
}

export default JobGroupsTabs;
